
export const helperTextWarning = `You are about to reach the maximum character limit.`;
export const helperTextError = `You have reached the character limit on this field.`;

export enum EMaxLength {
  Short = 255,
  Medium = 500,
  Long = 5000
}

export const maximumQuestion = 200;
export const maximumAnswer = 250;

export enum DefaultText {
  QuestionnaireTitle = 'Questionnaire Title',
  QuestionText = 'Type your question here',
  HelperText = 'Type your helper text here',
  AnswerText = 'Type your answer here',
  CheckboxText = 'Checkbox text goes here',
  DropdownOptionText = 'Option ',
  TitleTheme = 'Default',
  QuestionnaireForm = 'Lead Generation Form',
  EmailTemplate = 'Email Template ',
  ScheduleTitle = 'Select a date and time',
  PaymentTitle = 'Ready to finalise your booking?',
  PaymentSubtitle = 'You only have to pay a £30 booking to secure your time slot for that day.'
}

export const DELETE_SELECTED = 'deleteSelected';
export const DELETE_SINGLE = 'deleteSingle';

export const BRAND_NAME = 'Pipelyne';
export const LOGO_URL = 'assets/logo_pipelyne.svg';

export const MAX_DAY = 28;
export const MAX_MONTH = 365;
